import { useClock } from '@ligr/shared';
import { createContainer } from 'unstated-next';
import { OverlayContainer } from './overlayContainer';
import { DelayedSummary } from './delayedSummaryContainer';
const useClockContainer = () => {
    const overlayContainer = OverlayContainer.useContainer();
    const match = overlayContainer.match;
    const { data: { matchSummary }, skewMs } = DelayedSummary.useContainer();
    const clockData = useClock(Object.assign(Object.assign({}, match), { sport: { name: match.sportName } }), matchSummary, skewMs);
    return { clockData };
};
export const ClockContainer = createContainer(useClockContainer);
//# sourceMappingURL=clockContainer.js.map